import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_STARTER_EXPERIENCE_READY_TO_SHARE_PREDRAFTED = defineFcm(
	'starter_experience_ready_to_share_predrafted',
)
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				experimentName: { type: 'string', optional: true },
			},
		}),
	)
	.withDefault({
		experimentName: undefined,
	})
	.toConfig();
